export default [
  {
    title: 'Accueil',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Liste pharmaciens',
    route: 'pharmaciens',
    icon: 'PlusSquareIcon',
  },
  {
    title: 'Articles',
    icon: 'AlignCenterIcon',
    children: [
      {
        title: 'Listes',
        route: 'articles-list',
      },
      {
        title: 'Ajouter',
        route: 'articles-ajout',
      }
    ],
  },
  {
    title: 'Participants forum',
    route: 'participants',
    icon: 'UsersIcon',
  },
  {
    title: 'Liste sponsors',
    route: 'sponsors',
    icon: 'PlusSquareIcon',
  }
  
]
